import { Ref, ref, toRef } from "vue";
import { backend, search } from "../services";
import { useUserStore } from "../stores/user";
import { useTour } from "./tour";

export function useToursDAO() {
  const user = useUserStore();
  const accountId = toRef(user, "accountId");
  const tours = ref([]);

  const q = ref("");
  const when = ref([]);

  async function $read() {
    const { data } = await backend.getTours({ accountId: accountId.value });
    tours.value = data.map((o) => {
      const tour = useTour();
      tour.$fromDTO(o);
      return tour;
    });
  }

  async function $find(query: { q: Ref<string>; when: Ref<Array<number>> }) {
    q.value = query.q.value;
    when.value = query.when.value;
    const data = await search.searchTours({ q: q.value, when: when.value });
    tours.value = data.hits.map(({ document }) => {
      const tour = useTour();
      tour.$fromDTO({
        ...document,
        effectiveFrom: document.effectiveFrom.toString(),
      });
      return tour;
    });
  }

  return {
    tours,
    $read,
    $find,
  };
}
